/* eslint-disable prettier/prettier */
import navBar from "assets/i18next/en/navBar";
import sideBar from "assets/i18next/en/sideBar";
import mpsa from "assets/i18next/en/mpsa";
import authentication from "assets/i18next/en/authentication";
import message from "assets/i18next/en/message"
import user from "assets/i18next/en/user"
import global from "assets/i18next/en/global"

const translation = Object.assign({}, navBar, sideBar, mpsa, authentication, message, user, global);

export default translation;
